import { useState } from 'react';
import { Eye, EyeOff } from '../Icons';

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function TextField({ id, label, icon: Icon, error, hint, right, ...props }) {
  return (
    <div className={`fld ${error ? 'fld--error' : ''}`}>
      <div className="fld__label">
        <label htmlFor={id}>{label}</label>
        {right}
      </div>
      <div className="fld__control">
        {Icon && <Icon className="fld__icon" width={18} height={18} />}
        <input
          id={id}
          name={id}
          aria-invalid={!!error}
          aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined}
          {...props}
        />
      </div>
      {error ? (
        <p className="fld__error" id={`${id}-error`} role="alert">{error}</p>
      ) : hint ? (
        <p className="fld__hint" id={`${id}-hint`}>{hint}</p>
      ) : null}
    </div>
  );
}

export function PasswordField({ id, label, icon: Icon, error, hint, right, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className={`fld ${error ? 'fld--error' : ''}`}>
      <div className="fld__label">
        <label htmlFor={id}>{label}</label>
        {right}
      </div>
      <div className="fld__control">
        {Icon && <Icon className="fld__icon" width={18} height={18} />}
        <input
          id={id}
          name={id}
          type={show ? 'text' : 'password'}
          aria-invalid={!!error}
          aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined}
          {...props}
        />
        <button
          type="button"
          className="fld__toggle"
          onClick={() => setShow((s) => !s)}
          aria-label={show ? 'Hide password' : 'Show password'}
        >
          {show ? <EyeOff width={18} height={18} /> : <Eye width={18} height={18} />}
        </button>
      </div>
      {error ? (
        <p className="fld__error" id={`${id}-error`} role="alert">{error}</p>
      ) : hint ? (
        <p className="fld__hint" id={`${id}-hint`}>{hint}</p>
      ) : null}
    </div>
  );
}

export function SubmitButton({ loading, children }) {
  return (
    <button type="submit" className="btn btn--primary btn--lg btn--block" disabled={loading}>
      {loading && <span className="spinner" aria-hidden="true" />}
      {children}
    </button>
  );
}

